import api from '@app/api/api';

const controller = "crfTiposAgrupador";
export interface CrfTipoAgrupador {
  id: string;
  data: TPData;
}

export interface TPData {
  nome: string;
  codigo: number;
}

export const getAllDisciplinas = () => api.get<CrfTipoAgrupador[]>(`${controller}/disciplinas`);
export const getAllDisciplinasOptions = () =>
  api.get<CrfTipoAgrupador[]>(`${controller}/disciplinas`)
    .then((values: any) => (values || []).map((v: any) => ({ text: v.data.nome, value: v.id.toString() })));

export const getAllTipos = () => api.get<CrfTipoAgrupador[]>(`${controller}/tipos`);
export const getAllTiposOptions = () =>
  api.get<CrfTipoAgrupador[]>(`${controller}/tipos`)
    .then((values: any) => (values || []).map((v: any) => ({ text: v.data.nome, value: v.id.toString() })));

export const createDisciplina = (tipoAgrupador: Omit<TPData, 'codigo'>) =>
  api.post<CrfTipoAgrupador>(`${controller}/disciplinas`, tipoAgrupador);

export const createTipo = (tipoAgrupador: Omit<TPData, 'codigo'>) => api.post<CrfTipoAgrupador>(`${controller}/tipos`, tipoAgrupador);

export const updateDisciplina = (tipoAgrupador: any) => {
  const data = {
    id: tipoAgrupador.id,
    nome: tipoAgrupador.data.nome,
  };

  return api
    .put<boolean>(`${controller}/disciplinas/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const updateTipo = (tipoAgrupador: any) => {
  const data = {
    id: tipoAgrupador.id,
    nome: tipoAgrupador.data.nome,
  };

  return api
    .put<boolean>(`${controller}/tipos/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const deleteDisciplina = (id: string) => api.delete(`${controller}/disciplinas/${id}`);
export const deleteTipo = (id: string) => api.delete(`${controller}/tipos/${id}`);

export interface OrcamentoAcronimoAgrupador {
  contaContabilCcId: string;
  acronimoId: string;
  projetoId: string;
}

export const updateOrdemByAcronimoAgrupador = (acronimoAgrupador: OrcamentoAcronimoAgrupador) => {
  return api
    .put<boolean>(`${controller}/contaContabilCc/${acronimoAgrupador.contaContabilCcId}`, acronimoAgrupador)
    .then(result => true)
    .catch(err => false);
};